import styles from "./Abbreviation.module.css";
import classNames from "classnames";
import { useId, useState, type JSX } from "react";

type AbbreviationProps = {
  long: string;
  short: string;
  addComma?: boolean;
};

const Abbreviation = (props: AbbreviationProps): JSX.Element => {
  const { short = "", long, addComma } = props;
  const fieldId = useId();

  const [isShowing, setIsShowing] = useState(false);

  const controlClasses = classNames(styles.tooltip, {
    [styles.visuallyHidden]: !isShowing,
  });

  return (
    <span className={styles.abbrContainer}>
      {addComma && ", "}
      <abbr
        tabIndex={0}
        aria-describedby={fieldId}
        onFocus={() => setIsShowing(true)}
        onMouseOver={() => setIsShowing(true)}
        onMouseOut={() => setIsShowing(false)}
        onBlur={() => setIsShowing(false)}
      >
        {short}
      </abbr>
      <span role="tooltip" id={fieldId} className={controlClasses}>
        {long}
      </span>
    </span>
  );
};

export { Abbreviation };
